import { termsOfUse } from './terms_of_use';
import { Page, Container, DocumentBody, Copyright } from './styles';
import { motion } from 'framer-motion';

const TermsOfUse = () => {
  return (
    <Page>
      <Container>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
          style={{ width: '100%' }}
        >
          <DocumentBody dangerouslySetInnerHTML={{ __html: termsOfUse }} />
        </motion.div>
        <Copyright>Copyright © 2024</Copyright>
      </Container>
    </Page>
  );
};

export default TermsOfUse;
